import { FC } from "react";
import { Tooltip } from "react-bootstrap";
import { FaQuestionCircle } from "react-icons/fa";

type Props = {
  averageScore: number;
};

export const Summary: FC<Props> = ({ averageScore }) => {
  const lowWidth = Math.min(averageScore, 50);
  const mediumWidth = averageScore > 50 ? Math.min(averageScore - 50, 30) : 0;
  const highWidth = averageScore > 80 ? Math.min(averageScore - 80, 20) : 0;

  return (
    <div style={{ width: "100%", textAlign: "center", padding: 2 }}>
      <p
        style={{
          marginTop: 1,
          fontWeight: "bold",
          fontSize: "18px",
          marginBottom: "3rem",
        }}
      >
        Optimization Grade{" "}
        {/* <Tooltip title="This represents your overall optimization score. A higher score means better performance."> */}
        {/* <FaQuestionCircle
            style={{
              fontSize: "24px",
              color: "#bbb",
              cursor: "pointer",
              paddingBottom: "3px",
            }}
          /> */}
        {/* </Tooltip> */}
      </p>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          marginTop: 1,
        }}
      >
        <p
          style={{
            position: "absolute",
            left: `${Math.min(averageScore, 100)}%`,
            transform: "translateX(-50%)",
            fontSize: "14px",
            fontWeight: "bold",
            color: "#000",
          }}
        >
          {averageScore}
        </p>
      </div>

      <div
        style={{
          display: "flex",
          width: "100%",
          maxWidth: 500,
          height: 8,
          borderRadius: 4,
          backgroundColor: "#ddd",
          overflow: "hidden",
          marginTop: 2,
          margin: "auto",
        }}
      >
        <div
          style={{
            width: `${lowWidth}%`,
            backgroundColor: "#dc3545",
            transition: "width 0.5s ease",
          }}
        />
        <div
          style={{
            width: `${mediumWidth}%`,
            backgroundColor: "#ffc107",
            transition: "width 0.5s ease",
          }}
        />
        <div
          style={{
            width: `${highWidth}%`,
            backgroundColor: "#198754",
            transition: "width 0.5s ease",
          }}
        />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          maxWidth: 500,
          margin: "auto",
          marginTop: 1,
        }}
      >
        <p style={{ fontSize: "12px", fontWeight: "bold", color: "#dc3545" }}>
          Low
        </p>
        <p style={{ fontSize: "12px", fontWeight: "bold", color: "#ffc107" }}>
          Medium
        </p>
        <p style={{ fontSize: "12px", fontWeight: "bold", color: "#198754" }}>
          High
        </p>
      </div>
    </div>
  );
};
